import React from 'react';
import { PageWrapper, CustomerSearch } from '../../components';

const HomePage = () => (
  <PageWrapper>
    <CustomerSearch />
  </PageWrapper>
);

export default HomePage;
